import React from 'react';

const WrapComponent = ({ blockTypes, wrap: Wrap }) => {
  const customProps = {
    page: null,
    readOnly: null,
  };
  return {
    initialize: ({ getProps }) => {
      const { page, readOnly } = getProps();
      customProps.page = page;
      customProps.readOnly = readOnly;
    },
    decorators: [
      {
        strategy: (contentBlock, callback) => {
          if (blockTypes.indexOf(contentBlock.getType()) !== -1) {
            callback(0, contentBlock.getText().length);
          }
        },
        component: props => <Wrap {...props} {...customProps} />,
      },
    ],
  };
};

export default WrapComponent;
